import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import styles from './Collapse.module.css';

export interface CollapseProps extends HTMLAttributes<HTMLDivElement> {
  open: boolean;
}

/**
 * Animates its content open and closed. Closed content stays mounted, so its
 * state survives, but it can't be seen, focused or read by screen readers.
 * Put padding inside the children: padding on this box would not collapse.
 */
export const Collapse = ({
  open,
  className,
  children,
  ...rest
}: CollapseProps) => (
  <div
    {...rest}
    // `inert` drops focus and clicks the moment it closes, not after the
    // close animation. React 18 has no `inert` prop and React 19 reads the ''
    // that 18 needs as false, so it is set on the element. The ref is inline
    // so it runs on every render and follows `open`. Once React 19 lands
    // (#6854), replace this ref with `inert={!open}`.
    ref={(el) => {
      el?.toggleAttribute('inert', !open);
    }}
    className={classNames(styles.collapse, className)}
    data-open={open || undefined}
    aria-hidden={!open || undefined}
  >
    <div className={styles.content}>{children}</div>
  </div>
);
